import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  MenuItem,
  Box,
  Typography,
  LinearProgress
} from '@mui/material';
import { Upload } from '@mui/icons-material';

const AircraftDocumentDialog = ({
  open,
  onClose,
  documentForm,
  setDocumentForm,
  uploading,
  uploadProgress,
  onUpload
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Upload Document</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              select
              label="Document Type"
              value={documentForm.documentType}
              onChange={(e) => setDocumentForm({ ...documentForm, documentType: e.target.value })}
            >
              <MenuItem value="MANUAL">Manual</MenuItem>
              <MenuItem value="SPECIFICATIONS">Specifications</MenuItem>
              <MenuItem value="WARRANTY">Warranty</MenuItem>
              <MenuItem value="SERVICE_HISTORY">Service History</MenuItem>
              <MenuItem value="CERTIFICATE_OF_REGISTRATION">Certificate of Registration</MenuItem>
              <MenuItem value="CERTIFICATE_OF_AIRWORTHINESS">Certificate of Airworthiness</MenuItem>
              <MenuItem value="INSURANCE">Insurance</MenuItem>
              <MenuItem value="TYPE_CERTIFICATE">Type Certificate</MenuItem>
              <MenuItem value="OPERATOR_PERMIT">Operator Permit</MenuItem>
              <MenuItem value="IMPORT_DOCUMENTS">Import Documents</MenuItem>
              <MenuItem value="MODIFICATIONS">Modifications</MenuItem>
              <MenuItem value="OTHER">Other</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Document Sub-Type (Optional)"
              placeholder="e.g., Aircraft Manual, Flight Manual"
              value={documentForm.documentSubType}
              onChange={(e) => setDocumentForm({ ...documentForm, documentSubType: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Description (Optional)"
              value={documentForm.description}
              onChange={(e) => setDocumentForm({ ...documentForm, description: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="outlined"
              component="label"
              fullWidth
              startIcon={<Upload />}
            >
              {documentForm.file ? documentForm.file.name : 'Select File'}
              <input
                type="file"
                hidden
                onChange={(e) => setDocumentForm({ ...documentForm, file: e.target.files[0] })}
                accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.mp4,.mov,.txt"
              />
            </Button>
            {uploading && (
              <Box sx={{ mt: 2 }}>
                <LinearProgress variant="determinate" value={uploadProgress} />
                <Typography variant="caption" sx={{ mt: 1 }}>Uploading... {uploadProgress}%</Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onUpload}
          variant="contained"
          disabled={uploading || !documentForm.file || !documentForm.documentType}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AircraftDocumentDialog;

